// extracted by mini-css-extract-plugin
export default {"roomCardSwiper":"RoomCard_roomCardSwiper__xRstO"};